import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Navbar from "../Navbar";
import { RiExportFill } from "react-icons/ri";
import { toast } from "react-toastify";
import { MdAddToPhotos } from "react-icons/md";
import Cookies from "js-cookie";
import { MdNotStarted } from "react-icons/md";
import { PiFilesFill } from "react-icons/pi";
import { GoFileSubmodule } from "react-icons/go";
import { FaEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import Menu_Items from "../Menu_Items";

function Export_Details() {
  const { id, int_id } = useParams();
  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [spl, setspl] = useState(false)
  const [user, setuser] = useState(false)
  const [monitor, setmonitor] = useState(false)
  const [Export_details, setExport_details] = useState([]);
  const [statusval, setstatusval] = useState(false);
  const [delete_box, setdelete_box] = useState(false);
  const [delete_id, setdelete_id] = useState(null)
  const [sortOrder, setSortOrder] = useState("asc"); // Track sorting order

  const menus = [
    {
      name: 'Integrations',
      id
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'All In Bounds', id, int_id, type: 'Out' }
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const getvalues = async () => {
    await axios
      .get(`/out_bound/${int_id}`)
      .then((res) => {
        setExport_details(res.data);
      })
      .catch((err) => {
        toast.error("getvalues API Error", {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  // Function to handle sorting
  const handleSort = (name) => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle order
    const sorted = [...Export_details].sort((a, b) => {
      if (typeof a[name] === "string") {
        return newOrder === "asc"
          ? a[name].localeCompare(b[name])
          : b[name].localeCompare(a[name]);
      } else {
        return newOrder === "asc" ? a[name] - b[name] : b[name] - a[name]; // Numerical sorting
      }
    });
    setExport_details(sorted);
    setSortOrder(newOrder);
  };
  const handle_status = async (id, status) => {
    await axios.patch(`/out_bound/status/${id}`, status === 0 ? { Status: 1 } : { Status: 0 }).then((res) => {
      setstatusval((prevStatus) => !prevStatus);
    })
      .catch((err) => {
        toast.error(err.message, {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  const handle_delete = async () => {
    await axios.delete(`/out_bound/${delete_id}`).then((res) => {
      getvalues();
      setdelete_box(false)
      setdelete_id(null)
    })
      .catch((err) => {
        toast.error(`Detail Could not be Deleted`, {
          autoClose: 2000,
        });
      });
  };
  const trigger = async () => {
    await axios.get('/out_bound/check/trigger').then(res => {
      console.log(res.data);
    }).catch(err => {
      console.log(err);
    })
  }
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else if (level === 'Integ Special') {
      setspl(true)
    }
    else if (level === 'Integ User') {
      setuser(true)
    }
    else {
      setmonitor(true)
    }

  };
  useEffect(() => {
    getvalues();      // Wait for getvalues() to finish
    get_level();
  }, [statusval]);

  return (
    <div className="container df fdc jc ac">
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <RiExportFill className='page_icon db' />
              <p>Out Bound Details</p>
              {/* <button className='m1 btn green' onClick={trigger}>trigger</button> */}
            </div>
            {
              (su_admin || admin || spl || user) && (<Link to={`/out_bound/add/${id}/${int_id}`} className='w3' ><MdAddToPhotos className='icon3 g' /></Link>)
            }
          </div>
          <table className="df fdc ac">
            <thead>
              <tr className="df js ac" style={{ cursor: "pointer" }}>
                <th>S.No</th>
                <th onClick={() => { handleSort('Name') }}>Export Name {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('Export_To') }}>Export Type {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('Data_Type') }}>File Type {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {Export_details.length === 0 && (
                <div className="no_Records h50 w100  df jc ac">
                  <p>No Records</p>
                </div>
              )}
              {Export_details.length > 0 &&
                Export_details.map((obj, index) => {
                  return (
                    <tr className="df jc ac" key={index}>
                      <td className="df js ac">{index + 1}</td>
                      <td className="df js ac">{obj.Name}</td>
                      <td className="df js ac">{obj.Export_Type}</td>
                      <td className="df js ac">{obj.File_Type}</td>
                      <td className="df jc ac gap2">
                        {(
                          !monitor &&
                          <Link to={`#`} className={`df jc ac g tooltip ${obj.Status === 0 ? "g" : "r"}`} onClick={() => { handle_status(obj.id, obj.Status); }} icon-name={obj.Status === 0 ? "Start" : "Stop"}>
                            <MdNotStarted className="icon2" />
                          </Link>
                        )}
                        {(
                          <Link
                            to={`/out_bound/log/${id}/${int_id}/${obj.Sequence_No}`}
                            className="tooltip"
                            icon-name="Log Details"
                          >
                            <PiFilesFill className="icon2 db" />
                          </Link>
                        )}
                        {(
                          <Link
                            to={`/out_bound/${id}/${int_id}/${obj.id}`}
                            className="tooltip"
                            icon-name="Tables"
                          >
                            <GoFileSubmodule className="icon2 db" />
                          </Link>
                        )}
                        {(!monitor &&
                          <>
                            <Link
                              to={`/out_bound/edit/${id}/${int_id}/${obj.id}`}
                              className="tooltip"
                              icon-name="Edit"
                            >
                              <FaEdit className="icon2 db" />
                            </Link>
                            <Link to={`#`} className="tooltip" icon-name="Delete">
                              <MdDeleteForever
                                className="icon2 r"
                                onClick={() => { setdelete_box(true); setdelete_id(obj.id) }}
                              />
                            </Link>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      {/* <div className="h_btn df jc ae">
        <p className="df jc ac">Out Bound</p>
        <div className="menu_bar h5 w25 df je ac gap1">
          <Link to={home_path} className="menu_icon df jc ac">
            <AiFillHome className="icon2" />
          </Link>
          {(admin_level || user_level || monitor_level) && (
            <Link to={`/integ/${id}`} className="menu_icon df jc ac">
              <IoChevronBackCircleSharp className="icon2" />
            </Link>
          )}
          {admin_level && (
            <>
              <Link to={`/company/users/${id}`} className="menu_icon df jc ac">
                <FaUsers className="icon2" />
              </Link>
              <Link
                to={`/out_bound/add/${id}/${int_id}`}
                className="menu_icon df jc ac"
              >
                <MdOutlineAddBox className="icon2" />
              </Link>
            </>
          )}
          <Link to={"/"} className="menu_icon df jc ac">
            <MdLogout className="icon2" />
          </Link>
        </div>
      </div> */}
      {/* <Back location={`/integ/${id}`} /> */}
      {
        delete_box &&
        <div className='dialog_bg'>
          <div className='delete_box'>
            <h1 className='h5 w80 df ac r'>Delete</h1>
            <p className='h5 w80'>Are You Sure You Want to Delete This Item ?</p>
            <div className='h5 w40 df jb ac'>
              <button className='btn l_black' onClick={() => setdelete_box(false)}>Cancel</button>
              <button className='btn red' onClick={() => handle_delete()}>Delete</button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Export_Details;
